import React from 'react'

// import Float from './Float'
// import Footer from './Footer'
import Header from './Header'
import Main from './Main'
import TabNavs from './TabNavs'

const RootLayout: React.FC = () => {
  return (
    <>
      <Header />
      <Main />
      {/* <Footer /> */}
      {/* <Float /> */}
      <TabNavs />
    </>
  )
}

export default RootLayout
